import styled from "styled-components";

export const GrossPremiumPrice = styled.span`
  color: #040222;
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;